// --- File: dummyBlocksNew.js ---

export const draftBlocksData = [
  {
    index: 1,
    blockID: "BLOCK-0001",
    timestamp: "2025-09-13T18:55:00Z",
    status: "draft",
    previousHash:
      "0000000000000000000000000000000000000000000000000000000000000000",
    merkleRoot:
      "a1b2c3d4e5f678901234567890abcdef1234567890abcdef1234567890abcd",
    payload: {
      MainTDR: {
        holderName: "Rahul Patil",
        locationOfLand: "Pimpri, Pune",
        district: "Pune",
        state: "Maharashtra",
        villageCity: "Pimpri",
        surveyNo: "CTS 100/1",
        fsiCreditSqm: 1500,
        documentHash:
          "5e884898da28047151d0e56f8dc6292773603d0d6aabbdd4a0e1a2b0f3b3f9ab",
      },
      utilisationHistory: [
        {
          date: "2025-08-20",
          utiliserName: "Skyline Builders",
          usedAt: "Wakad, Pune",
          usedAtDistrict: "Pune",
          usedAtState: "Maharashtra",
          usedAtVillageCity: "Wakad",
          surveyNo: "CTS 120/4",
          areaUtilizedSqm: 400,
          balanceAreaSqm: 1100,
          documentHash:
            "2c1743a391305fbf367df8e4f069f9f9beba45f1c7a83e33d1f5f4e3f8b0d40d",
        },
        {
          date: "2025-09-10",
          utiliserName: "ABC Developers",
          usedAt: "Baner, Pune",
          usedAtDistrict: "Pune",
          usedAtState: "Maharashtra",
          usedAtVillageCity: "Baner",
          surveyNo: "CTS 452/1",
          areaUtilizedSqm: 500,
          balanceAreaSqm: 600,
          documentHash:
            "4b227777d4dd1fc61c6f884f48641d02f8f2f4e7e8c1f6a4a5e3b2d4c1e8a7b3",
        },
      ],
      meta: { createdBy: "PMRDA-Blockchain-Node-1" },
    },
    documents: {
      currentTDR: "path/to/current_tdr_doc1.pdf",
      previousTDR: "path/to/previous_tdr_doc0.pdf",
    },
    validatorsSignature: [
      {
        validatorID: "Validator-001",
        signature: "3045022100a1b2c3d4e5f678...",
        timestamp: "2025-09-13T19:00:00Z",
      },
      {
        validatorID: "Validator-002",
        signature: "3045022100f1e2d3c4b5a697...",
        timestamp: "2025-09-13T19:05:00Z",
      },
      {
        validatorID: "Validator-003",
        signature: "3045022100c4d3e2f1b5a697...",
        timestamp: "2025-09-13T19:10:00Z",
      },
    ],
    hash: "9a0b3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z7a8b9c0d1e2",
  },
  {
    index: 2,
    blockID: "BLOCK-0002",
    timestamp: "2025-09-13T19:15:00Z",
    status: "draft",
    previousHash:
      "9a0b3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z7a8b9c0d1e2",
    merkleRoot:
      "b1c2d3e4f5a678901234567890abcdef1234567890abcdef1234567890abcd",
    payload: {
      MainTDR: {
        holderName: "Sunil Deshmukh",
        locationOfLand: "Kothrud, Pune",
        district: "Pune",
        state: "Maharashtra",
        villageCity: "Kothrud",
        surveyNo: "CTS 200/2",
        fsiCreditSqm: 2000,
        documentHash:
          "6dcd4ce23d88e2ee9568ba546c007c63a3c6d02e5b8ab1b1d9e4c8f3e6a7b8c9",
      },
      utilisationHistory: [
        {
          date: "2025-09-05",
          utiliserName: "City Infra",
          usedAt: "Karvenagar, Pune",
          usedAtDistrict: "Pune",
          usedAtState: "Maharashtra",
          usedAtVillageCity: "Karvenagar",
          surveyNo: "CTS 88/9",
          areaUtilizedSqm: 500,
          balanceAreaSqm: 1500,
          documentHash:
            "9a0b3c4d5e6f7g8h9i0j1k2l3m4n5o6p7q8r9s0t1u2v3w4x5y6z7a8b9c0d1e2",
        },
        {
          date: "2025-09-12",
          utiliserName: "XYZ Constructions",
          usedAt: "Shivaji Nagar, Pune",
          usedAtDistrict: "Pune",
          usedAtState: "Maharashtra",
          usedAtVillageCity: "Shivaji Nagar",
          surveyNo: "CTS 300/2",
          areaUtilizedSqm: 700,
          balanceAreaSqm: 800,
          documentHash:
            "a1b2c3d4e5f678901234567890abcdef1234567890abcdef1234567890abcd",
        },
      ],
      meta: { createdBy: "PMRDA-Blockchain-Node-1" },
    },
    documents: {
      currentTDR: "path/to/current_tdr_doc2.pdf",
      previousTDR: "path/to/current_tdr_doc1.pdf",
    },
    validatorsSignature: [
      {
        validatorID: "Validator-001",
        signature: "3045022100gh1234...",
        timestamp: "2025-09-13T19:20:00Z",
      },
      {
        validatorID: "Validator-002",
        signature: "3045022100ij5678...",
        timestamp: "2025-09-13T19:25:00Z",
      },
      {
        validatorID: "Validator-003",
        signature: "3045022100kl9012...",
        timestamp: "2025-09-13T19:30:00Z",
      },
    ],
    hash: "b9c0d1e2f3g4h5i6j7k8l9m0n1o2p3q4r5s6t7u8v9w0x1y2z3a4b5c6d7e8f9",
  },
];

export const broadcastedBlocksData = [
  {
    index: 3,
    blockID: "BLOCK-0003",
    timestamp: "2025-09-14T10:30:00Z",
    status: "verified",
    previousHash:
      "b9c0d1e2f3g4h5i6j7k8l9m0n1o2p3q4r5s6t7u8v9w0x1y2z3a4b5c6d7e8f9",
    merkleRoot:
      "c1d2e3f4a5b678901234567890abcdef1234567890abcdef1234567890abcd",
    payload: {
      MainTDR: {
        holderName: "Amit Jadhav",
        locationOfLand: "Hadapsar, Pune",
        district: "Pune",
        state: "Maharashtra",
        villageCity: "Hadapsar",
        surveyNo: "CTS 500/7",
        fsiCreditSqm: 1800,
        documentHash:
          "d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2d2",
      },
      utilisationHistory: [
        {
          date: "2025-09-01",
          utiliserName: "Prime Builders",
          usedAt: "Magarpatta, Pune",
          usedAtDistrict: "Pune",
          usedAtState: "Maharashtra",
          usedAtVillageCity: "Magarpatta",
          surveyNo: "CTS 500/7",
          areaUtilizedSqm: 600,
          balanceAreaSqm: 1200,
          documentHash:
            "e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3e3",
        },
        {
          date: "2025-09-11",
          utiliserName: "Sunrise Developers",
          usedAt: "Koregaon Park, Pune",
          usedAtDistrict: "Pune",
          usedAtState: "Maharashtra",
          usedAtVillageCity: "Koregaon Park",
          surveyNo: "CTS 256/3",
          areaUtilizedSqm: 400,
          balanceAreaSqm: 800,
          documentHash:
            "f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4f4",
        },
      ],
      meta: { createdBy: "PMRDA-Blockchain-Node-2" },
    },
    documents: {
      currentTDR: "path/to/current_tdr_doc3.pdf",
      previousTDR: "path/to/current_tdr_doc2.pdf",
    },
    validatorsSignature: [
      {
        validatorID: "Validator-001",
        signature: "3045022100mn3456...",
        timestamp: "2025-09-14T10:40:00Z",
      },
      {
        validatorID: "Validator-002",
        signature: "3045022100op7890...",
        timestamp: "2025-09-14T10:45:00Z",
      },
      {
        validatorID: "Validator-003",
        signature: "3045022100qr1234...",
        timestamp: "2025-09-14T10:50:00Z",
      },
    ],
    hash: "c9d8e7f6g5h4i3j2k1l0m9n8o7p6q5r4s3t2u1v0w9x8y7z6a5b4c3d2e1f0g9",
  },
  {
    index: 4,
    blockID: "BLOCK-0004",
    timestamp: "2025-09-14T12:00:00Z",
    status: "pending",
    previousHash:
      "c9d8e7f6g5h4i3j2k1l0m9n8o7p6q5r4s3t2u1v0w9x8y7z6a5b4c3d2e1f0g9",
    merkleRoot:
      "d1e2f3a4b5c678901234567890abcdef1234567890abcdef1234567890abcd",
    payload: {
      MainTDR: {
        holderName: "Priya Kulkarni",
        locationOfLand: "Viman Nagar, Pune",
        district: "Pune",
        state: "Maharashtra",
        villageCity: "Viman Nagar",
        surveyNo: "CTS 600/5",
        fsiCreditSqm: 2200,
        documentHash:
          "f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5f5",
      },
      utilisationHistory: [
        {
          date: "2025-09-07",
          utiliserName: "Metro Constructions",
          usedAt: "Viman Nagar, Pune",
          usedAtDistrict: "Pune",
          usedAtState: "Maharashtra",
          usedAtVillageCity: "Viman Nagar",
          surveyNo: "CTS 600/5",
          areaUtilizedSqm: 800,
          balanceAreaSqm: 1400,
          documentHash:
            "a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6a6",
        },
        {
          date: "2025-09-13",
          utiliserName: "Pune Developers",
          usedAt: "Yerwada, Pune",
          usedAtDistrict: "Pune",
          usedAtState: "Maharashtra",
          usedAtVillageCity: "Yerwada",
          surveyNo: "CTS 420/8",
          areaUtilizedSqm: 600,
          balanceAreaSqm: 800,
          documentHash:
            "b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7b7",
        },
      ],
      meta: { createdBy: "PMRDA-Blockchain-Node-2" },
    },
    documents: {
      currentTDR: "path/to/current_tdr_doc4.pdf",
      previousTDR: "path/to/current_tdr_doc3.pdf",
    },
    validatorsSignature: [
      {
        validatorID: "Validator-001",
        signature: "3045022100st3456...",
        timestamp: "2025-09-14T12:10:00Z",
      },
      {
        validatorID: "Validator-002",
        signature: "3045022100uv7890...",
        timestamp: "2025-09-14T12:15:00Z",
      },
      {
        validatorID: "Validator-003",
        signature: "3045022100wx1234...",
        timestamp: "2025-09-14T12:20:00Z",
      },
    ],
    hash: "d8c7b6a5f4e3d2c1b0a9m8n7o6p5q4r3s2t1u0v9w8x7y6z5a4b3c2d1e0f9g8",
  },
];
  